import { Outlet } from "react-router-dom";
import Registration from "../pages/collage/auth/Registeration";
import Login from "../pages/collage/auth/Login";
import Dashboard from "../pages/collage/Dashboard";
import Students from "../pages/collage/Students";


const collageRoutes=[
    {
        path:'/college',
        element:<Outlet/>,
        children:[
            {
                path:'registration',
                element:<Registration/>
            },
            {
                path:'login',
                element:<Login/>
            },{
                index:true,
                element:<Dashboard/>
            },{
                path:'students',
                element:<Students/>
            },
        ]
    }
]
export default collageRoutes